import { render, staticRenderFns } from "./productIssueProgress.vue?vue&type=template&id=f4583e26&scoped=true&"
import script from "./productIssueProgress.vue?vue&type=script&lang=js&"
export * from "./productIssueProgress.vue?vue&type=script&lang=js&"
import style0 from "./productIssueProgress.vue?vue&type=style&index=0&id=f4583e26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4583e26",
  null
  
)

export default component.exports